import apiClient from '@/services/apiClient'
import type { UpdateUserPayload } from '@/domain/users/entities/user.entity'

export const ADMIN_USERS_PATH = '/admin/users'

export class UsersRemoteDatasource {
  async list(page: number, limit: number) {
    const response = await apiClient.get(ADMIN_USERS_PATH, {
      params: { page, limit },
    })
    return response.data
  }

  async getById(id: string) {
    const response = await apiClient.get(`${ADMIN_USERS_PATH}/${encodeURIComponent(id)}`)
    return response.data
  }

  async update(id: string, payload: UpdateUserPayload) {
    const response = await apiClient.patch(
      `${ADMIN_USERS_PATH}/${encodeURIComponent(id)}`,
      payload
    )
    return response.data
  }

  async delete(id: string) {
    await apiClient.delete(`${ADMIN_USERS_PATH}/${encodeURIComponent(id)}`)
  }
}
